<template>
  <div
    v-if="isLoggedIn"
    class="IntegratorBar"
  >
    <div id="integrator-selector-container">
      <v-select
        id="integrator-selector"
        v-model="integrator"
        density="compact"
        :placeholder="getPlaceholderCompany"
        :readonly="isSingleVisibleCompany"
        :items="getVisibleCompanies"
        prepend-icon="fas fa-map-marker-alt"
        item-title="name"
        item-value="id"
        hide-details
        @update:model-value="changeIntegrator"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "IntegratorBar",
  props: {
    isLoggedIn: Boolean,
    userProfile: Object,
    selectedCustomer: Object,
    setSelectedCustomer: Function,
  },
  data() {
    return {
      integrator: this.selectedCustomer,
    };
  },
  computed: {
    isSingleVisibleCompany() {
      return this.userProfile?.visibleCompanies?.length === 1;
    },
    getVisibleCompanies() {
      return this.userProfile?.visibleCompanies ?? [];
    },
    getPlaceholderCompany() {
      return this.userProfile?.companyName ?? "";
    },
  },
  watch: {
    selectedCustomer: {
      handler: function () {
        this.integrator = this.selectedCustomer;
      },
    },
  },
  methods: {
    changeIntegrator() {
      const companyIndex = this.userProfile?.visibleCompanies?.findIndex(
        (obj) => {
          return obj.id === this.integrator;
        },
      );

      let integrator = this.selectedCustomer;
      if (companyIndex >= 0) {
        integrator = this.userProfile?.visibleCompanies[companyIndex];
        this.setSelectedCustomer(integrator);
      }

      if (this.$route.path.indexOf("/projects/") === 0) {
        this.$router.push({
          name: "projects",
          params: { customerId: integrator.id },
        });
      } else if (this.$route.path.indexOf("/details/") === 0) {
        this.$router.push({
          name: "projects",
          params: { customerId: integrator.id },
        });
      } else if (this.$route.path.indexOf("/calcsessions/") === 0) {
        this.$router.push({
          name: "calcsessions",
          params: { customerId: integrator.id },
        });
      } else if (this.$route.path.indexOf("/calc/") === 0) {
        this.$router.push({
          name: "calcsessions",
          params: { customerId: integrator.id },
        });
      } else if (this.$route.path.indexOf("/support/tickets/") === 0) {
        this.$router.push({
          name: "support.tickets",
          params: { customerId: integrator.id },
        });
      }
    },
  },
});
</script>

<style>
.IntegratorBar {
  background: #c1c1c1;
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
}

#integrator-selector {
  width: 300px;
  z-index: 1002;
}

#integrator-selector-container {
  max-width: 300px;
  width: 100%;
  z-index: 1001;
  padding-left: 12px;
}
</style>
